import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, Zap, Infinity, Star, Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-8 pb-8 md:pt-10 md:pb-12 px-4 overflow-hidden flex flex-col items-center text-center" data-id="element-138">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-139" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="relative z-10 max-w-4xl mx-auto" data-id="element-140">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-dark-lighter border border-gold/30 text-gold-light text-xs font-semibold tracking-wider mb-3" data-id="element-141">
          <span data-id="element-142">🏛️</span> DESCUBRE EL FASCINANTE MUNDO DE LA ANTIGUA GRECIA{' '}
          <span data-id="element-143">🏛️</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading leading-tight mb-4 text-white" data-id="element-144">
          Grecia <span className="text-gold-light" data-id="element-145">Legendaria</span>
        </h1>

        <p className="text-base md:text-lg text-gray-300 mb-4 max-w-2xl mx-auto" data-id="element-146">
          La colección definitiva para explorar dioses, héroes, mitos, criaturas
          y los grandes misterios de una de las civilizaciones más
          extraordinarias de la historia.
        </p>

        <motion.img src="https://cdn.magicpatterns.com/uploads/i5ZwUnxoh3KE9dmXFH2xFU/ChatGPT_Image_6_jul_2026,_14_56_56_-_Editado.png" alt="MegaPack Grecia Legendaria — 6 Tomos y 4 Bonos sobre la Antigua Grecia" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="w-full max-w-lg md:max-w-xl mx-auto mb-5 drop-shadow-[0_0_50px_rgba(212,168,67,0.25)]" data-id="element-147" />

        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 mb-6 text-xs md:text-sm text-gray-300 font-medium" data-id="element-148">
          <div className="flex items-center gap-1.5" data-id="element-149">
            <BookOpen className="w-4 h-4 text-gold" data-id="element-150" />
            <span data-id="element-151">6 módulos cuidadosamente desarrollados</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-152">
            <Gift className="w-4 h-4 text-gold" data-id="element-153" />
            <span data-id="element-154">4 bonos exclusivos</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-155">
            <Star className="w-4 h-4 text-gold" data-id="element-156" />
            <span data-id="element-157">Una colección única sobre la Antigua Grecia</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-158">
            <Zap className="w-4 h-4 text-gold" data-id="element-159" />
            <span data-id="element-160">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-161">
            <Infinity className="w-4 h-4 text-gold" data-id="element-162" />
            <span data-id="element-163">Acceso de por vida</span>
          </div>
        </div>

        <motion.a href="#oferta-premium" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-gold to-gold-light text-dark font-bold text-base md:text-lg rounded-lg shadow-[0_0_30px_rgba(212,168,67,0.3)] hover:shadow-[0_0_40px_rgba(212,168,67,0.5)] transition-all animate-pulse-slow mb-4" data-id="element-164">
          → Quiero descubrir Grecia
        </motion.a>

        <div className="flex flex-wrap justify-center items-center gap-3 md:gap-5 text-xs text-gray-400" data-id="element-165">
          <div className="flex items-center gap-1.5" data-id="element-166">
            <Shield className="w-3.5 h-3.5" data-id="element-167" />
            <span data-id="element-168">Garantía 7 días</span>
          </div>
          <span className="hidden sm:inline text-dark-border" data-id="element-169">|</span>
          <div className="flex items-center gap-1.5" data-id="element-170">
            <Lock className="w-3.5 h-3.5" data-id="element-171" />
            <span data-id="element-172">Pago seguro</span>
          </div>
          <span className="hidden sm:inline text-dark-border" data-id="element-173">|</span>
          <div className="flex items-center gap-1.5" data-id="element-174">
            <CreditCard className="w-3.5 h-3.5" data-id="element-175" />
            <span data-id="element-176">Acceso de por vida</span>
          </div>
        </div>
      </motion.div>
    </section>;
}